exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._17oierHrKR {\n  position: relative; }\n", ""]);

// exports
exports.locals = {
	"wrap": "_17oierHrKR"
};